// Module
var code = `<breadcrumbs></breadcrumbs>
<center-header ng-if="\$ctrl.hasCenter()" center="\$ctrl.center"></center-header>
<section class="box">
  <sub-header header="\$ctrl.getHeaderTitle()"></sub-header>
  <div class="tab-menu">
    <ul class="nav-tabs">
      <li class="active">
        <a data-target="#center_tab_data" data-toggle="tab">
          <span>Center data</span>
        </a>
      </li>
      <li>
        <a data-target="#center_tab_officers" data-toggle="tab" ng-if="\$ctrl.hasCenter()">
          <span>Center officers</span>
        </a>
      </li>
    </ul>
  </div>

  <form name="\$ctrl.centerForm">
    <div class="tab-content">
      <div class="tab-pane active" id="center_tab_data">
        <div class="form-column">
          <form-section form-title="'Basic data'">
            <form-section-field field-title="'Name'">
              <input ng-model="\$ctrl.center.name" type="text" ng-disabled="!\$ctrl.isFormInputEnabled()" required/>
            </form-section-field>
            <form-section-field field-title="'Reference no.'" ng-if="!\$ctrl.isFormInputEnabled()">
              <input ng-model="\$ctrl.center.id" type="text" disabled/>
            </form-section-field>
            <form-section-field field-title="'Branch'">
              <select ng-model="\$ctrl.center.branchId"
                      ng-options="b.id as b.name for b in \$ctrl.branches"
                      ng-change="\$ctrl.onBranchChange()"
                      ng-disabled="!\$ctrl.isFormInputEnabled()"
                      required>
              </select>
            </form-section-field>
          </form-section>

          <form-section form-title="'Bank Officers'">
            <form-section-field field-title="'Loan Officer'">
              <select
                ng-model="\$ctrl.center.loanOfficerId"
                ng-options="u.id as u.fullName for u in \$ctrl.loanOfficers"
                ng-disabled="!\$ctrl.isFormInputEnabled()"
                required
              ></select>
            </form-section-field>
            <form-section-field field-title="'Loan Collector'">
              <select
                ng-model="\$ctrl.center.loanCollectorId"
                ng-options="u.id as u.fullName for u in \$ctrl.loanCollectors"
                ng-disabled="!\$ctrl.isFormInputEnabled()"
              ></select>
            </form-section-field>
          </form-section>
        </div>
      </div>

      <div class="tab-pane" id="center_tab_officers" ng-if="\$ctrl.hasCenter()">
        <div class="form-column">
          <form-section form-title="'Center Fund'">
            <form-section-field field-title="'Center Fund Account'">
              <selectize
                options="\$ctrl.centerChiefCbuAccounts"
                config="\$ctrl.selectAccountConfig"
                ng-model="\$ctrl.center.centerFundAccountId"
                ng-disabled="!\$ctrl.isFormInputEnabled()">
              </selectize>
              <help title="Center fund accounts are CBU Accounts owned by the Center Chief"></help>
            </form-section-field>
          </form-section>
        </div>

        <center-officers
          officers="\$ctrl.center.centerLeaders"
          customers="\$ctrl.center.customers"
          edit-mode="\$ctrl.isFormInputEnabled()"
          on-change="\$ctrl.retrieveCenterOfficersAccounts"
          ng-if="\$ctrl.center && \$ctrl.center.customers && \$ctrl.center.centerLeaders"
        ></center-officers>
      </div>
    </div>
  </form>

  <div class="clearfix"></div>

  <div class="summary-actions">
    <button class="btn btn-warning"
            type="button"
            ng-click="\$ctrl.enableEditMode()"
            command-access="UpdateCenter"
            ng-disabled="!\$ctrl.center.active"
            ng-if="!\$ctrl.editMode && \$ctrl.hasCenter()">
      Edit
    </button>

    <button class="btn btn-warning"
            type="button"
            ng-click="\$ctrl.cancel()"
            ng-if="\$ctrl.isFormInputEnabled()">
      Cancel
    </button>
    <button class="btn btn-primary"
            ng-disabled="\$ctrl.centerForm.\$invalid"
            type="button"
            ng-click="\$ctrl.save()"
            command-access="{{\$ctrl.hasCenter() ? 'UpdateCenter' : 'CreateCenter'}}"
            ng-if="\$ctrl.isFormInputEnabled()">
      Save
    </button>
  </div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/center/details/center-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;